import React, { ReactNode } from 'react';

import { Card } from '../../../components/card/card';
import { Text } from '../../../components/text/text';
import { Title } from '../../../components/title/title';
import './eco-card.scss';

type EcoCardProps = {
  title: string | ReactNode;
  text: string | ReactNode;
  icon: any;
  children?: any;
  reverted?: boolean;
};

export const EcoCard: React.FC<EcoCardProps> = ({ children, title, text, reverted, icon }) => (
  <Card
    density="large"
    className="rc-eco__card"
    icon={icon}
    content={
      <React.Fragment>
        <Title level="3" weight="bold">
          {title}
        </Title>

        <Text>{text}</Text>
      </React.Fragment>
    }
    reverted={reverted}
    afterContent={children}
  />
);
